module.exports = "/_next/static/images/21b52b4f06c25ca48f1d354ae7958475-phone@2x.png";